"use strict";

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PeerAPI = void 0;

var dcl_catalyst_client_1 = require("dcl-catalyst-client");

var api_1 = require("./api");

var PeerAPI = /*#__PURE__*/function (_api_1$BaseAPI) {
  _inherits(PeerAPI, _api_1$BaseAPI);

  function PeerAPI(url) {
    var _this;

    _classCallCheck(this, PeerAPI);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PeerAPI).call(this, url));
    _this.cache = {};
    _this.lambdasClient = new dcl_catalyst_client_1.LambdasClient("".concat(url, "/lambdas"));
    return _this;
  }
  /**
   * Fetches a profile only once by caching the promise
   * to prevent concurrent flying requests
   *
   * @param address - The address of the profile to retrieve.
   */


  _createClass(PeerAPI, [{
    key: "fetchProfile",
    value: function fetchProfile(address) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(address in this.cache)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", this.cache[address]);

              case 2:
                this.cache[address] = this.lambdasClient.fetchProfiles([address.toLowerCase()]).then(function (profiles) {
                  return profiles[0];
                });
                return _context.abrupt("return", this.cache[address]);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
    /**
     * Gets the default entity structure for a profile.
     */

  }, {
    key: "getDefaultProfileEntity",
    value: function getDefaultProfileEntity() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var profile;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.request('GET', '/content/entities/profile?pointer=default' + Math.floor(Math.random() * 128 + 1));

              case 2:
                profile = _context2.sent;
                return _context2.abrupt("return", profile[0]);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }]);

  return PeerAPI;
}(api_1.BaseAPI);

exports.PeerAPI = PeerAPI;